// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputHistory[data-v-9e69d2d4]{padding:1.333vw 1.333vw;z-index:9999}.inputHistory div[data-v-9e69d2d4]{height:6.667vw;line-height:6.667vw;background:hsla(0,0%,94.1%,.4196078431372549);border-radius:1.333vw;margin:2.667vw 0;padding:1.333vw;box-sizing:content-box;cursor:pointer}.inputHistory div span[data-v-9e69d2d4]{cursor:pointer;width:100%;height:100%;display:inline-block}", ""]);
// Exports
module.exports = exports;
